import React from 'react';
import { Card } from 'antd/lib';
import PropTypes from 'prop-types';

interface IWidget {
  title?: any;
  children?: any;
  styleName?: any;
  cover?: any;
  extra?: any;
  actions?: any;
  styles?: any;
  bodyStyle?: any;
}

const Widget: React.FC<IWidget> = ({
  title,
  children,
  styleName,
  cover,
  extra,
  actions,
  styles,
  bodyStyle,
}) => {
  return (
    <Card
      title={title}
      style={styles}
      actions={actions}
      cover={cover}
      className={`gx-card-widget gx-justify-content-center ${styleName}`}
      extra={extra}
      bodyStyle={bodyStyle}
    >
      {children}
    </Card>
  );
};

export default Widget;

Widget.defaultProps = {
  styleName: '',
};

Widget.propTypes = {
  title: PropTypes.node,
  extra: PropTypes.node,
  cover: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
};
